import axios, { AxiosPromise } from 'axios';
import { IPkkSearchQueryData, IPkkSearchCoordinateData } from 'types';
import { PKK_API_PATH } from 'consts';
import { getOmjsViewInstance } from '../selectors';

export const pkkSearchByQuery = (data: IPkkSearchQueryData): AxiosPromise<GeoJSON.FeatureCollection> => {
    const viewInstance = getOmjsViewInstance(false);
    const { protocol, hostname } = viewInstance.getProject().apiUrlLocation;
    return axios.get(`${protocol}//${hostname}/${PKK_API_PATH}/search/query/`, { params: data });
};

export const pkkSearchByCoordinate = (data: IPkkSearchCoordinateData): AxiosPromise<GeoJSON.FeatureCollection> => {
    const viewInstance = getOmjsViewInstance(false);
    const { protocol, hostname } = viewInstance.getProject().apiUrlLocation;
    return axios.get(`${protocol}//${hostname}/${PKK_API_PATH}/search/coordinate/`, { params: data });
};
